import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, TagStatus } from './index';
import { TagCreateBody } from './create';

export type TagUpdateData = AnyObject;

export type TagUpdateResponse = TagUpdateData;

export interface TagUpdateBody extends Partial<TagCreateBody> {
  status?: TagStatus;
}

export interface TagUpdatePayload {
  id: string;
  body: TagUpdateBody
}

export const tagUpdate = (payload: TagUpdatePayload): Action<TagUpdatePayload> => ({
  type: actions.tagUpdateTrigger.toString(),
  payload,
});

export const tagUpdateClear = (): Action => ({
  type: actions.tagUpdateClear.toString(),
});

export function* tagUpdateRequestSaga({ payload }: Action<TagUpdatePayload>) {
  yield put({
    type: actions.tagUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.tagUpdateError.toString(),
      payload: {
        message: 'TagUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/articles/tags/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TagUpdateData, TagUpdateResponse>(
    response,
    actions.tagUpdateSuccess.toString(),
    actions.tagUpdateError.toString(),
    false,
    (tagUpdateData) => tagUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.tagUpdateTrigger.toString(),
    defaultProcessingSaga(
      tagUpdateRequestSaga,
      {
        error: actions.tagUpdateError.toString(),
        locationCancel: actions.tagUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.tagUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.tagUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.tagUpdateErrorReset.toString(),
    });
  });
}
